<template scope>
  <div>
    <div class="steps-page-wioa">
      <PageSteps
        v-for="(step, index) in stepObjects"
        :key="index"
        :totalSteps="Object.values(stepObjects).length"
        :stepNumber="index + 1"
        :currentStep="currentPage"
        :data="{}"
        :stepRouteName="step.routePage"
      />
    </div>
    <div class="ts-app-wioa">
      <slot />
    </div>
  </div>
  <!-- <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-landing-dashboard">
        <div class="steps-page-wioa">
            <PageSteps
              v-for="(step, index) in stepObjects"
              :key="index"
              :totalSteps="Object.values(stepObjects).length"
              :stepNumber="index + 1"
              :currentStep="currentPage"
              :data="{}"
              :stepRouteName="step.routePage"
            />
        </div>
        <div class="ts-app-wioa">
          <slot />
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import PageSteps from "@/components/PageSteps.vue";
export default {
  name: "CheckListTemplate",
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      stepObjects: [
        {
          routePage: "WioaChecklist",
        },
        {
          routePage: "WioaChecklistTwo",
        },
        {
          routePage: "WioaChecklistThree",
        },
        {
          routePage: "WioaChecklistFour",
        },
        {
          routePage: "WioaChecklistFive",
        },
        {
          routePage: "WioaChecklistSix",
        },
        {
          routePage: "WioaChecklistSeven",
        },
        {
          routePage: "WioaChecklistEight",
        },
        {
          routePage: "WioaChecklistNine",
        },
        {
          routePage: "WioaChecklistTen",
        },
        {
          routePage: "WioaChecklistEleven",
        },
      ],
    };
  },
  components: { PageSteps },
};
</script>

<style lang="scss">
@import "@/assets/scss/project/wioa.scss";
</style>
